import { render, staticRenderFns } from "./talentDetail.vue?vue&type=template&id=5f2175b8&scoped=true"
import script from "./talentDetail.vue?vue&type=script&lang=js"
export * from "./talentDetail.vue?vue&type=script&lang=js"
import style0 from "./talentDetail.vue?vue&type=style&index=0&id=5f2175b8&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2175b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f2175b8')) {
      api.createRecord('5f2175b8', component.options)
    } else {
      api.reload('5f2175b8', component.options)
    }
    module.hot.accept("./talentDetail.vue?vue&type=template&id=5f2175b8&scoped=true", function () {
      api.rerender('5f2175b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/talentDetail.vue"
export default component.exports